import {gql, QueryResult, useQuery} from '@apollo/client';
import {RenewInterval} from 'components/checkout/query/types';
import {API_APPT, ApiAppt} from 'components/checkout/query/types.api-appt';
import {API_AUTH, ApiAuth} from 'components/checkout/query/types.api-auth';

const getAppt = gql`
${API_APPT}
${API_AUTH}

query (
	$appt: ID!
	$referrer: String
) {
	auth {
		...ApiAuth
	}

    appt(id: $appt) {
        info: details {
			...ApiAppt
		}
    }

	credits: auth {
		user {
			credits {
				product {
					id
				}
				count
			}

			memberships {
				product {
					id
				}
				upcoming {
                    price {
                        quantity
                        total
                    }
					renewInterval
                }
				renewsOn {
					date
				}
			}
		}
	}
}`;

interface Vars {
	appt: string
	referrer: string
}

export interface Result {
	auth: ApiAuth

	appt: {
		info: ApiAppt
	}

	credits: {
		user?: {
			credits: {
                product: {
                    id: string
                }
                count: number
            }[]

			memberships: {
				product: {
					id: string
				}
				upcoming: {
					price: {
						quantity: number
						total: number
					}
					renewInterval: RenewInterval
				}
				renewsOn: {
					date: string
				}
			}[]
		}
	}
}

export type ApptResult = QueryResult<Result, Vars>

export const useAppt = (appt: string): ApptResult => {
	return useQuery<Result, Vars>(getAppt, {
		variables: {
			appt,
			referrer: '',
		},
	});
};
